var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviewOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7 28.15C18.0333 28.15 15.65 27.4333 13.55 26C11.45 24.5667 9.91667 22.7 8.95 20.4C9.58333 18.8667 10.4917 17.525 11.675 16.375C12.8583 15.225 14.2333 14.3167 15.8 13.65L17.75 15.6C16.4833 15.9667 15.325 16.5667 14.275 17.4C13.225 18.2333 12.3667 19.2333 11.7 20.4C12.6 22.0333 13.85 23.3167 15.45 24.25C17.05 25.1833 18.8 25.65 20.7 25.65C21.7 25.65 22.675 25.5167 23.625 25.25C24.575 24.9833 25.45 24.6 26.25 24.1L28 25.85C26.9667 26.5833 25.8333 27.15 24.6 27.55C23.3667 27.95 22.0667 28.15 20.7 28.15ZM30.25 23.85L28.5 22.1C28.7333 21.8333 28.95 21.5583 29.15 21.275C29.35 20.9917 29.5333 20.7 29.7 20.4C28.8667 18.9 27.7417 17.7 26.325 16.8C24.9083 15.9 23.3333 15.3667 21.6 15.2L19.15 12.75C21.9833 12.3833 24.6333 12.9083 27.1 14.325C29.5667 15.7417 31.35 17.7667 32.45 20.4C32.1833 21.0667 31.8667 21.6833 31.5 22.25C31.1333 22.8167 30.7167 23.35 30.25 23.85ZM37.45 39.6L34.25 36.4H5.7C4.86667 36.4 4.15833 36.1083 3.575 35.525C2.99167 34.9417 2.7 34.2333 2.7 33.4V4.85L0 2.15L2.15 0L39.6 37.45L37.45 39.6ZM5.7 33.4H31.25L5.7 7.8V33.4ZM38.7 32.3L35.7 29.3V8.25H14.65L6.8 0.4H35.7C36.5333 0.4 37.2417 0.691667 37.825 1.275C38.4083 1.85833 38.7 2.56667 38.7 3.4V32.3Z",
    fill: "#5F11EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewOff);
export default __webpack_public_path__ + "static/media/preview-off.eb778a8338f7b0b76eec11df3ffa9177.svg";
export { ForwardRef as ReactComponent };